import Constants from '@/Constants';
import React, { ReactElement, useRef } from 'react';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import './style.scss';

interface Props {
    className?: string;
    children: ReactElement;
    popoverContent: ReactElement | null;
    showNotification: boolean;
    closeNotification: () => void;
}

const ChatNotification: React.FC<Props> = (props: Props) => {
    const { className, children, showNotification, closeNotification, popoverContent } = props;
    const containerRef = useRef(null);

    return (
        <div ref={containerRef}>
            <OverlayTrigger
                container={containerRef.current}
                key="auto"
                overlay={
                    <Popover className={`chatBotNotification ${className || ''}`} id="chatBotNotification">
                        <Button className="closeButton" onClick={closeNotification}>
                            <i className="material-icons-outlined align-middle closeIcon">{Constants.icons.CLOSE}</i>
                        </Button>
                        {popoverContent}
                    </Popover>
                }
                placement="auto"
                show={showNotification}
            >
                {children}
            </OverlayTrigger>
        </div>
    );
};

export default ChatNotification;
